// extracted by mini-css-extract-plugin
export default {"h1":"BaseElements_h1__aPVhS","h2":"BaseElements_h2__5vji2","h3":"BaseElements_h3__BB734","p":"BaseElements_p__wfGa8"};